var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUsersAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.5003L3.65833 15.1003C4.75 11.1587 7.625 9.16699 10.5 9.16699",
    stroke: "#4B4433",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.15023C12.8012 9.15023 14.6667 7.28475 14.6667 4.98356C14.6667 2.68237 12.8012 0.816895 10.5 0.816895C8.19881 0.816895 6.33333 2.68237 6.33333 4.98356C6.33333 7.28475 8.19881 9.15023 10.5 9.15023Z",
    stroke: "#4B4433",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 19.1668C16.9679 19.1668 18.8333 17.3013 18.8333 15.0002C18.8333 12.699 16.9679 10.8335 14.6667 10.8335C12.3655 10.8335 10.5 12.699 10.5 15.0002C10.5 17.3013 12.3655 19.1668 14.6667 19.1668Z",
    stroke: "#4B4433",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H16.3333",
    stroke: "#4B4433",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 13.3335V16.6668",
    stroke: "#4B4433",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsersAdd);
export default __webpack_public_path__ + "static/media/ic-users-add.c1e9470cc2124d61748c09b31b9b09bd.svg";
export { ForwardRef as ReactComponent };